import { render } from "./WebBuilderBuilds.vue?vue&type=template&id=6bce120e"
import script from "./WebBuilderBuilds.vue?vue&type=script&lang=js"
export * from "./WebBuilderBuilds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__